import { render } from "./SearchIcon.vue?vue&type=template&id=4ad6aa50&bindings={}"
import script from "./SearchIcon.vue?vue&type=script&lang=ts"
export * from "./SearchIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script